import React from 'react'

import Breadcrumbs from '../../components/common/Breadcrumbs/Breadcrumbs.tsx'

const Payments = () => {
  return (
    <>
      <Breadcrumbs
        pageName="Płatności"
        breadcrumbs={[
          { label: 'Strona główna', path: '/' },
          { label: 'Płatności' }
        ]}
      />

      <div>Payments</div>
    </>
  )
}

export default Payments
